<template>
  <div>
    <!-- <client-only> -->
      <transition>
        <div class="rightMenu">
          <div class="item message-box" @click="clkIM()">
            <!-- <span class="span-title-icon">在线客服</span> -->
            <div :class="['icon1',{
              'close-calss':!isShow
            }]">
              <!-- <svg-icon name="kefu2" size="27"></svg-icon> -->
              <img src='/static/img/kefu.png' width="64px" height="64px">
              <div v-if="!isShow" class="bg-img">Close</div>
            </div>
          </div>
        </div>
      </transition>
    <!-- </client-only> -->
  </div>
</template>
<script>
import Vue from "vue";
import { getCookie, setCookie } from "@/ask/cookiejs.js";

function debounce(fn, delay) {
  let timer = null; //借助闭包
  return function () {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(fn, delay); // 简化写法
  };
}
export default {
  name: "App",
  components: {},
  data() {
    return {
      isRouterAlive: true,
      rightMenu: -1,
      isShow:true
    };
  },
  provide() {
    return {
      reload: this.reload,
    };
  },
  mounted() {
    // 打开im对话框
    this.openImDialog();
  },
  methods: {
    openImDialog() {
      // console.log(222,11111);
      if (this.isLogin) {
        return false;
      }
      // 首页计数
      if (this.$route.fullPath !== "/") {
        return false;
      }
      // 未登录的情况下，前三次访问网站，在进入网站第十秒弹出IM对话框
      let imVisitCount = getCookie("imVisitCount");
      let that = this;
      if (imVisitCount) {
        imVisitCount = JSON.parse(imVisitCount);
        if (imVisitCount < 3) {
          setCookie("imVisitCount", ++imVisitCount);
          let timer = setTimeout(function () {
            // 打开im对话框
            that.clkIM();
            // 清除计时器
            clearTimeout(timer);
            timer = null;
          }, 10000);
        }
      } else {
        setCookie("imVisitCount", 1);
        let timer = setTimeout(function () {
          // 打开im对话框
          that.clkIM();
          // 清除计时器
          clearTimeout(timer);
          timer = null;
        }, 10000);
      }
    },

    // 移入此元素触发， 子元素不触发
    mouseEnterMenu(type) {
      this.rightMenu = type;
    },
    // 移出此元素触发， 子元素不触发
    mouseLeaveMenu() {
      this.rightMenu = -1;
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },

    //点击右侧导航栏跳转
    clkIM() {
      // this.SDInstantMessaging()
      // this.$TrackPoint(() => [
      //   "instant_messaging",
      //   {
      //     entrance: document.title,
      //   },
      // ]);
      
      this.isShow = !this.isShow;
      if(this.isShow){
        $(".CHATS-PANEL-HOLDER").hide();
      }else{
        $(".CHATS-PANEL-HOLDER").show();
      }
      
    },
  },
};
</script>
<style lang="scss" type="text/css" rel="stylesheet" scoped="scoped">
#app {
  width: 100%;
  height: 100%;
}
.rightMenu {
  display: flex;
  flex-direction: column;
  position: fixed;
  z-index: 9999;
  right: 14px;
  top: 75vh;
  .close-calss{
    img{
      position: absolute;
    }
     &:hover{
       .bg-img{
         background: rgba(0,0,0,0.4000);
         position: relative;
         width: 50px;
         height: 50px;
         line-height: 50px;
         text-align: center;
         color: #FFFFFF;
         font-size: 13px;
             border-radius: 60px;
       }
      
    }
  }
 
}

.rightMenu {
  .item {
    width: 56px;
    height: 56px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);
    border-radius: 30px;

    position: relative;
    margin-top: 10px;

    .span-title {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #0c5ee4;
      line-height: 56px;
      letter-spacing: 1px;

      text-align: center;
      display: block;
      cursor: pointer;
    }
  }

  .span-title {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #0c5ee4;
    line-height: 56px;
    letter-spacing: 1px;

    text-align: center;
    display: block;
    cursor: pointer;
  }

  .span-title-2 {
    display: block;
    width: 30px;
    height: 30px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #0c5ee4;
    line-height: 15px;
    letter-spacing: 1px;

    padding: 13px 11px 13px 15px;
    cursor: pointer;
  }

  .first-icon {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    cursor: pointer;

    // .red-circle {
    //   width: 8px;
    //   height: 8px;
    //   background: #cf3737;
    //   border-radius: 50%;

    //   position: absolute;
    //   top: 8px;
    //   right: 8px;
    // }
  }

  .message-info {
    display: none;
    position: absolute;
    right: 61px;
    top: 5px;

    width: 230px;
    height: 46px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);
    border-radius: 10px;

    .flex-box {
      display: flex;

      .message-icon {
        padding: 13px 14px;
      }

      .text {
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 46px;

        width: 170px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }

  .message-box {
    .icon1 {
      // display: block;
      opacity: 1;
      @extend .first-icon;
      transition: all 1s;
    }

    // .span-title-icon {
    //   opacity: 0;
    //   display: none;
    //   @extend .span-title-2;
    //   transition: all 1s;
    // }
  }

  // .message-box:hover {
  //   .icon1 {
  //     opacity: 0;
  //     display: none;
  //     transition: all 1s;
  //   }

  //   .span-title-icon {
  //     opacity: 1;
  //     display: block;
  //     transition: all 1s;
  //   }
  // }
}
</style>



// WEBPACK FOOTER //
// src/layouts/defaults.vue